import axios from 'axios';
import { getOrder } from 'network/ApiAxiosTickets'
import React,{useState,useEffect} from 'react'

function ClientViewOrder() {
    const [orderDetails, setorderDetails] = useState(false);
    const [mainEventInfo, setmainEventInfo] = useState();
console.log(window.location.search.split('=')[1])
    useEffect(() => {
        fetchOrder()
        fetchMainEventInfo()
    }, []);

    const fetchOrder = async () => {
        const resp = await getOrder(window.location.search.split('=')[1])
        if (resp.data) {
            console.log(resp.data)
            setorderDetails(resp.data)
        } else {
            console.error("Failed to fetch order")
        }
    }

    const fetchMainEventInfo = async () => {
        return await axios.post('https://new.geticketsonline.com:9876/event/all', { param: 'eventInfo' })
            .then(response => {
                setmainEventInfo(response.data.records);
            })
            .catch(error => {
                console.error(`Error fetching color for ticket ${ticketID}:`, error);
            })
    }

  return (
    <>
        <div className='container'>
            <h1 className='text-center'>Order Details</h1>
            {orderDetails != false ?
                <div>
                    <p><strong>Client Name:</strong> {orderDetails.clientName}</p>
                    <p><strong>Total Amount:</strong> ${orderDetails.total}</p>
                    <p><strong>Tickets:</strong></p>
                    {/*<ul>
                        {orderDetails.tickets.map(ticket => (
                            <li key={ticket._id}>{ticket.name} - ${ticket.price}</li>
                        ))}
                    </ul>*/}
                    {orderDetails.cart.map((cartItem,cartIndex)=>{
                    return <div>
                                <div key={cartItem._id + cartIndex} style={{backgroundColor: cartItem.color }}>
                                    <p style={{textShadow: '-1px -1px 0 #fff, 1px -1px 0 #fff, -1px 1px 0 #fff, 1px 1px 0 #fff',fontWeight:'bold'}}>
                                        {cartItem.name}
                                    </p>
                                </div>
                                <p>
                                    Event Info: {
                                        mainEventInfo && mainEventInfo.find(event => event._id === cartItem.mainEventId)
                                        ? mainEventInfo.find(event => event._id === cartItem.mainEventId).sellerDescription
                                        : 'Description not available'
                                    }
                                </p>
                            </div>
                  })}
                </div> : <p className='text-center'>Loading order details...</p>
                }
        </div>
    </>
  )
}

export default ClientViewOrder